/* eslint-disable */
export default {
  notActivated: '停用',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
